export default "__VITE_ASSET__DmhEXtRQ__"